module.exports = __webpack_public_path__ + "static/media/white_logo.a5f68582.svg";